export const CheckboxCircleIcon = ({ color, size }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size ? size : "22"}
        height={size ? size : "22"}
        fill="none"
        viewBox="0 0 22 22"
    >
        <path
            stroke={color ? color : "#000"}
            strokeLinecap="square"
            strokeWidth="2"
            d="M6 10.786 9.522 14 15 9m6 2c0 5.523-4.477 10-10 10S1 16.523 1 11 5.477 1 11 1s10 4.477 10 10Z"
        ></path>
    </svg>
);

export const FailedCircleIcon = ({ color, size }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size ? size : "24"}
        height={size ? size : "24"}
        fill="none"
        viewBox="0 0 24 24"
    >
        <path
            stroke={color ? color : "#000"}
            strokeWidth="2"
            d="M12 5v10m0 2v2m11-7c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z"
        ></path>
    </svg>
);

export const DeleteBinIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
    >
        <path
            fill="#EC6363"
            d="M13.5 3.6H18v1.8h-1.8v11.7a.9.9 0 0 1-.9.9H2.7a.9.9 0 0 1-.9-.9V5.4H0V3.6h4.5V.9a.9.9 0 0 1 .9-.9h7.2a.9.9 0 0 1 .9.9zm.9 1.8H3.6v10.8h10.8zM6.3 8.1h1.8v5.4H6.3zm3.6 0h1.8v5.4H9.9zM6.3 1.8v1.8h5.4V1.8z"
        ></path>
    </svg>
);

export const ClearIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        fill="none"
        viewBox="0 0 18 17"
    >
        <path
            fill="#EC6363"
            d="m6.502 6.019-4.37 4.476 4.586 4.696h1.033v-.002h1.035l3.336-3.416zm1.25-1.279 5.619 5.755 2.497-2.558-5.62-5.754zm3.531 10.45h6.181v1.808H9.517L5.987 17 .26 11.134a.92.92 0 0 1 0-1.279L9.624.265a.87.87 0 0 1 1.25 0l6.867 7.033a.92.92 0 0 1 0 1.278z"
        ></path>
    </svg>
);

export const EditIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="21"
        fill="none"
        viewBox="0 0 19 21"
    >
        <path
            fill="#8294A1"
            d="M4.392 14.664 14.534 4.522l-1.415-1.415L2.978 13.25v1.415zm.828 2H.977V12.42L12.412.986a1 1 0 0 1 1.415 0l2.828 2.828a1 1 0 0 1 0 1.415zm-4.243 2h18v2h-18z"
        ></path>
    </svg>
);

export const TickIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="14"
        fill="none"
        viewBox="0 0 26 14"
    >
        <path
            fill="#85CF29"
            d="m12.707 8.904 1.644 1.645 9.153-9.153a1 1 0 0 1 1.414 0l.233.233a1 1 0 0 1 0 1.414L15.059 13.136a1 1 0 0 1-1.415 0L7.647 7.138a1 1 0 0 1 0-1.414l.232-.233a1 1 0 0 1 1.415 0l1.767 1.768zm.002-3.293L17.769.55a1 1 0 0 1 1.415 0l.228.228a1 1 0 0 1 0 1.414l-5.06 5.061zm-3.292 6.586-.939.939a1 1 0 0 1-1.414 0L1.066 7.138a1 1 0 0 1 0-1.414L1.3 5.49a1 1 0 0 1 1.414 0l.939.939h-.001z"
        ></path>
    </svg>
);

export const CancelIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
    >
        <path
            fill="#EC6363"
            d="m8.68 7.315 6.294-6.293a1 1 0 0 1 1.414 0l.586.586a1 1 0 0 1 0 1.414L10.68 9.315l6.293 6.293a1 1 0 0 1 0 1.414l-.586.586a1 1 0 0 1-1.414 0L8.68 11.315l-6.293 6.293a1 1 0 0 1-1.414 0l-.586-.586a1 1 0 0 1 0-1.414l6.293-6.293L.388 3.022a1 1 0 0 1 0-1.414l.586-.586a1 1 0 0 1 1.414 0z"
        ></path>
    </svg>
);

export const DatabaseIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="18"
        fill="none"
        viewBox="0 0 14 18"
    >
        <g clipPath="url(#clip0_81_3)">
            <path
                fill="#37A0F6"
                d="M7 0C3.133 0 0 1.79 0 4s3.133 4 7 4 7-1.79 7-4-3.133-4-7-4M0 6v3c0 2.21 3.133 4 7 4s7-1.79 7-4V6c0 2.21-3.133 4-7 4S0 8.21 0 6m0 5v3c0 2.21 3.133 4 7 4s7-1.79 7-4v-3c0 2.21-3.133 4-7 4s-7-1.79-7-4"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_81_3">
                <path fill="#fff" d="M0 0h14v18H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export const RefreshIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            fill={color ? color : "#666666"}
            d="M3.463 2.433A9.96 9.96 0 0 1 10 0c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L15 10h3A8 8 0 0 0 4.46 4.228zm13.074 15.134A9.96 9.96 0 0 1 10 20C4.477 20 0 15.523 0 10c0-2.136.67-4.116 1.81-5.74L5 10H2a8 8 0 0 0 13.54 5.772z"
        ></path>
    </svg>
);

export const ArrowRightTriangleIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="5"
        height="10"
        fill="none"
        viewBox="0 0 5 10"
    >
        <path fill={color ? color : "#4D4D4D"} d="M.25 9.404V.596L4.654 5z"></path>
    </svg>
);

export const ArrowDownIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="7"
        fill="none"
        viewBox="0 0 10 7"
    >
        <path
            fill={color ? color : "#1A1A1A"}
            d="M5 6.545.289 1.833l.878-.878L5 4.79 8.833.955l.878.878z"
        ></path>
    </svg>
)

export const CopyIcon = ({color}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="16"
        fill="none"
        viewBox="0 0 15 16"
    >
        <path
            fill={color ? color : "#239DCE"}
            d="M.917 12.969v-1.346h1.346v1.346zm0-2.95V8.675h1.346v1.346zm0-2.948V5.725h1.346v1.346zm2.948 8.846v-1.346h1.346v1.346zm.257-3.205V.084H14.25v12.628zm1.25-1.25H13V1.334H5.372zm1.442 4.455v-1.346H8.16v1.346zm-5.897 0v-1.346h1.346v1.346zm8.846 0v-1.346h1.346v1.346zM.917 4.122V2.776h1.346v1.346z"
        ></path>
    </svg>
);

export const LockedIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="15"
        fill="none"
        viewBox="0 0 14 15"
    >
        <path
            fill="#7E7E7E"
            d="M12.444 6h.778c.43 0 .778.336.778.75v7.5c0 .414-.348.75-.778.75H.778A.764.764 0 0 1 0 14.25v-7.5C0 6.336.348 6 .778 6h.778v-.75C1.556 2.35 3.993 0 7 0s5.444 2.35 5.444 5.25zM1.556 7.5v6h10.888v-6zm3.11 2.25h4.667v1.5H4.667zM10.89 6v-.75C10.889 3.179 9.148 1.5 7 1.5S3.111 3.179 3.111 5.25V6z"
        ></path>
    </svg>
);

export const UnlockedIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="15"
        fill="none"
        viewBox="0 0 14 15"
    >
        <path
            fill="#7E7E7E"
            fillRule="evenodd"
            d="M12.444 6h.778c.43 0 .778.336.778.75v7.5c0 .414-.348.75-.778.75H.778A.764.764 0 0 1 0 14.25v-7.5C0 6.336.348 6 .778 6h.778v-.75C1.556 2.35 3.993 0 7 0c2.111 0 3.942 1.159 4.845 2.853l-1.436.592C9.748 2.285 8.47 1.5 7 1.5c-2.148 0-3.889 1.679-3.889 3.75V6h9.333M1.556 7.5v6h10.888v-6zm7.777 2.25v1.5H4.667v-1.5z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const BranchIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
    >
        <path
            fill={color ? color : "#7E7E7E"}
            d="M4.105 5.79A3 3 0 0 0 7 8h4a5 5 0 0 1 4.927 4.146A3.001 3.001 0 0 1 15 18a3 3 0 0 1-1.105-5.79A3 3 0 0 0 11 10H7a4.98 4.98 0 0 1-3-1v3.17a3.001 3.001 0 1 1-2 0V5.83a3.001 3.001 0 1 1 2.105-.04M3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m12 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        ></path>
    </svg>
);

export const PlusIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 14 14"
    >
        <path stroke={color ? color : "#37A0F6"} strokeWidth="2.3" d="M7 0v14M0 7h14"></path>
    </svg>
);

export const ArrowRightIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="10"
        fill="none"
        viewBox="0 0 14 10"
    >
        <path
            fill="#fff"
            d="m8.539 9.712-.879-.904 3.183-3.182H.75v-1.25h10.093L7.66 1.193 8.54.289l4.711 4.712z"
        ></path>
    </svg>
);

export const ArrowLeftClassic = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="11"
        fill="none"
        viewBox="0 0 20 11"
    >
        <path
            stroke="#4D4D4D"
            strokeWidth="2"
            d="M3 5.5h17m-17 0L11.743 1M3 5.5l8.743 4.5"
        ></path>
    </svg>
);

export const ArrowRightClassic = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="11"
        fill="none"
        viewBox="0 0 20 11"
    >
        <path
            stroke="#4D4D4D"
            strokeWidth="2"
            d="M17 5.5H0m17 0L8.257 1M17 5.5 8.257 10"
        ></path>
    </svg>
);

export const SearchIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
    >
        <path
            fill={color ? color : "#9E9E9E"}
            d="m16.545 17.575-6.281-6.28q-.75.618-1.725.968t-2.017.35q-2.564 0-4.34-1.775T.406 6.5t1.776-4.34T6.52.383t4.34 1.776 1.777 4.34q0 1.07-.36 2.045a5.7 5.7 0 0 1-.96 1.696l6.281 6.281zM6.52 11.114q1.933 0 3.275-1.342 1.341-1.34 1.341-3.274 0-1.932-1.341-3.274-1.342-1.341-3.274-1.341-1.933 0-3.274 1.341-1.342 1.341-1.342 3.274t1.342 3.274 3.273 1.342"
        ></path>
    </svg>
);

export const DropdownIcon = ({ color }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 14 14"
    >
        <path
            fill={color ? color : "#4D4D4D"}
            d="M6.997 9.094 9.76 6.33l-.713-.696-2.05 2.05-2.05-2.05-.712.696zM7 13.33a6.2 6.2 0 0 1-2.47-.499 6.4 6.4 0 0 1-2.012-1.353 6.4 6.4 0 0 1-1.354-2.01 6.2 6.2 0 0 1-.499-2.47q0-1.315.499-2.47a6.4 6.4 0 0 1 1.353-2.012 6.4 6.4 0 0 1 2.01-1.354 6.2 6.2 0 0 1 2.47-.499q1.314 0 2.47.499 1.157.498 2.012 1.353t1.354 2.01q.499 1.156.499 2.47t-.499 2.47a6.4 6.4 0 0 1-1.353 2.012 6.4 6.4 0 0 1-2.01 1.354 6.2 6.2 0 0 1-2.47.499m-.002-1q2.234 0 3.784-1.55t1.55-3.784-1.55-3.783-3.784-1.55-3.783 1.55-1.55 3.783 1.55 3.784 3.783 1.55"
        ></path>
    </svg>
);

export const ExportIcon = ({ color }) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={color ? color : "#4D4D4D"}
    viewBox="0 0 24 24"
    >
        <path d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2zM14 9h5l-7 7-7-7h5V3h4z"></path>
    </svg>
);

export const AIIcon = ({ color }) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={color ? color : "#4D4D4D"}
    viewBox="0 0 24 24"
  >
    <path d="M16 21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h8zM12.339 2.009A6 6 0 0 0 19.99 9.66q.009.17.01.34a7.97 7.97 0 0 1-1.756 5.001c-.55.686-1.889 1.727-2.185 2.999H7.94c-.297-1.273-1.637-2.315-2.187-3.001a8 8 0 0 1 6.585-12.99m5.19-1.68a.507.507 0 0 1 .942 0l.253.61a4.37 4.37 0 0 0 2.25 2.327l.718.32a.53.53 0 0 1 0 .962l-.76.338a4.36 4.36 0 0 0-2.218 2.25l-.247.566a.506.506 0 0 1-.934 0l-.246-.565a4.36 4.36 0 0 0-2.22-2.251l-.76-.338a.53.53 0 0 1 0-.963l.718-.32A4.37 4.37 0 0 0 17.276.94z"></path>
  </svg>
);